import React from "react";
import { Container, Load, Text } from "./style";
import PropTypes from "prop-types";

export default function Loading({ text }) {
    return (
        <Container>
            <Load type={"spin"} color={"black"} height={150} width={50} />
            <Text>{text}</Text>
        </Container>
    );
}


Loading.propTypes = {
    text: PropTypes.string
};